import React, { useEffect, useRef } from "react";
// Prebuilt ES5 bundle: CRA 3 / webpack 4 cannot parse the widget ESM build (??=, widget >=7.45.2). Revert to the bare import after a webpack 5 upgrade.
import OktaSignIn from "@okta/okta-signin-widget/dist/js/okta-sign-in.no-polyfill.min.js";
//import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";

import "../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import "./OktaWidgetStyleOverrides.css";

//import config from "./config";

//var OktaSignIn = require('@okta/okta-signin-widget');

const OktaSignInWidget = ({ onSuccess, onError }) => {
  const widgetRef = useRef();
  useEffect(() => {
    if (!widgetRef.current) {
      return false;
    }

    //console.log("process.env", process.env);

    //Get the scopes from copnfig, it should be a comma separated string
    let scopesFromConfig = process.env.REACT_APP_OKTA_AuthenticationScopes;

    //convert the comma separated string to an array
    let scopes = scopesFromConfig.split(",").map((item) => item.trim());

    var searchParams = new URL(window.location.href).searchParams;

    let signInConfig = {
      issuer: `${process.env.REACT_APP_OKTA_ISSUER}`,
      clientId: `${process.env.REACT_APP_OKTA_CLIENTID}`,
      redirectUri: `${window.location.origin}/login/callback`,
      scopes: scopes,
      otp: searchParams.get('otp'),
      state: searchParams.get('state')
      // pkce: false, // Explicitly set pkce to false
    };
    const widget = new OktaSignIn(signInConfig);

    // console.log("widget config", signInConfig);

    // Search for URL Parameters to see if a user is being routed to the application to recover password
    // var searchParams = new URL(window.location.href).searchParams;
    // widget.otp = searchParams.get("otp");
    // widget.state = searchParams.get("state");
    widget
      .showSignInToGetTokens({
        el: widgetRef.current,
      })
      .then(onSuccess)
      .catch(onError);

    return () => widget.remove();
  }, [onSuccess, onError]);

  return <div ref={widgetRef} />;
};

export default OktaSignInWidget;
